import { render } from "./RedeemInvitePage.vue?vue&type=template&id=42a18a8c&ts=true"
import script from "./RedeemInvitePage.vue?vue&type=script&lang=ts"
export * from "./RedeemInvitePage.vue?vue&type=script&lang=ts"

import "./RedeemInvitePage.vue?vue&type=style&index=0&id=42a18a8c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__